import WhyPartnerWithUs from "@components/severalbrands/whyPartnerWithUs";
import MaximizeFirmGrowth from "./maximizeYourFirmGrowth";
import { MainImgTextSharedComponentElType } from "@components/severalbrands/ourStoryPage/mainSharedComponent";
const defaultPartnerData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with clients needing your legal expertise, navigating the complexities of the legal market with confidence.`,
            className: "default",
        },
        {
            text: `Let us help you unlock your firm's full potential and thrive in this competitive industry. Together, we can transform your marketing strategy into a powerful tool for success, ensuring that your legal solutions reach the clients who need them most.`,
            className: "default",
        },
    ],
    buttonText: "Partner With Us",
};
export interface ThirdSectionLegalProps {
    partnerData?: {
        title: string;
        titleClassName?: string;
        paragraphs: { text: string; className: string | "default" }[];
        buttonText: string;
    };
    growthList?: MainImgTextSharedComponentElType[];
}

export default function ThirdSection({
    growthList,
    partnerData,
}: ThirdSectionLegalProps) {
    return (
        <section>
            <MaximizeFirmGrowth list={growthList} />
            <div className="mt-32 lg:mt-56 lg:mb-48 mb-20">
                <WhyPartnerWithUs
                    partnerWitUSData={partnerData ?? defaultPartnerData}
                />
            </div>
        </section>
    );
}
